import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Music, Calendar, Ticket, Settings, ScrollText, Trophy, LogOut, Menu, Guitar } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { useAuth } from '@/lib/auth';

const NAV = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/admin/bandas', label: 'Bandas', icon: Music },
  { to: '/admin/etapas', label: 'Etapas', icon: Calendar },
  { to: '/admin/repescagem', label: 'Repescagem', icon: Trophy },
  { to: '/admin/configuracoes', label: 'Configurações', icon: Settings },
  { to: '/admin/logs', label: 'Logs', icon: ScrollText },
];

function SidebarContent({ onNavigate }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="flex flex-col h-full bg-card border-r border-border">
      <div className="px-5 py-5 border-b border-border">
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-lg bg-[var(--g66-amber)] flex items-center justify-center text-black">
            <Guitar className="w-5 h-5" strokeWidth={2.5} />
          </div>
          <div className="leading-tight">
            <div className="font-display text-lg text-white">GARAGE 66</div>
            <div className="text-[9px] uppercase tracking-widest text-muted-foreground">Admin</div>
          </div>
        </div>
      </div>
      <nav className="flex-1 p-3 space-y-1" data-testid="admin-sidebar-nav">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            onClick={onNavigate}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${
                isActive ? 'bg-[color:hsla(42,92%,52%,0.14)] text-[var(--g66-amber)] border-l-2 border-[var(--g66-amber)]' : 'text-muted-foreground hover:bg-secondary hover:text-white'
              }`
            }
            data-testid={`admin-nav-${item.to.split('/').pop()}`}
          >
            <item.icon className="w-4 h-4" /> {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-border">
        <div className="text-xs text-muted-foreground truncate mb-2">{user?.email}</div>
        <Button
          variant="secondary"
          size="sm"
          className="w-full"
          onClick={() => { logout(); nav('/admin/login'); }}
          data-testid="admin-logout-button"
        >
          <LogOut className="w-4 h-4 mr-2" /> Sair
        </Button>
      </div>
    </div>
  );
}

export default function AdminLayout() {
  const [openMobile, setOpenMobile] = useState(false);
  return (
    <div className="min-h-screen bg-background">
      <div className="flex">
        {/* Desktop sidebar */}
        <aside className="hidden lg:flex w-[260px] flex-shrink-0">
          <SidebarContent />
        </aside>

        <div className="flex-1 min-w-0">
          {/* Top bar (mobile) */}
          <header className="lg:hidden sticky top-0 z-30 bg-background/95 backdrop-blur border-b border-border h-14 flex items-center px-4">
            <Sheet open={openMobile} onOpenChange={setOpenMobile}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" data-testid="admin-sidebar-toggle">
                  <Menu className="w-5 h-5" />
                </Button>
              </SheetTrigger>
              <SheetContent side="left" className="p-0 w-[260px] bg-card">
                <SidebarContent onNavigate={() => setOpenMobile(false)} />
              </SheetContent>
            </Sheet>
            <div className="ml-3 font-display text-lg">GARAGE 66 ADMIN</div>
          </header>

          <main className="p-4 sm:p-6 lg:p-8">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
